import React from 'react';
import PropTypes from 'prop-types';
import { disputeDetails as TEXT } from 'locales/en/dispute';
import ButtonActions from 'components/ButtonActions';

const DisputeCta = ({ hideSubmitEvidenceButton, onClickSubmitEvidence, onClickRefund }) => {
  const actionClassName = 'block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer';

  return hideSubmitEvidenceButton ? (
    <button onClick={onClickRefund} className="w-40 px-0 btn btn-secondary h-11" type="button">
      {TEXT.refund}
    </button>
  ) : (
    <ButtonActions
      title='Actions'
    >
      <button
        className={actionClassName}
        onClick={onClickSubmitEvidence}
      >
        {TEXT.submitEvidence}
      </button>
      <button className={actionClassName} onClick={onClickRefund}>
        {TEXT.refund}
      </button>
    </ButtonActions>
  )
}

DisputeCta.propTypes = {
  hideSubmitEvidenceButton: PropTypes.bool,
  onClickSubmitEvidence: PropTypes.func,
  onClickRefund: PropTypes.func
}

export default DisputeCta;
